@if (open) {
  <div class="hd-overlay" (click)="onOverlayClick($event)" aria-modal="true" role="dialog" aria-label="Histórico de cambios">
    <aside class="hd-panel">
      <!-- Header -->
      <header class="hd-header">
        <fa-icon [icon]="faClockRotateLeft" class="hd-header-icon" aria-hidden="true"></fa-icon>
        <h2 class="hd-title">Histórico de cambios</h2>
        <button class="hd-close-btn" (click)="close.emit()" aria-label="Cerrar histórico">
          <fa-icon [icon]="faXmark"></fa-icon>
        </button>
      </header>

      <!-- Date snapshot picker -->
      <section class="hd-snapshot-section" aria-label="Ver estado a fecha">
        <div class="hd-snapshot-label">
          <fa-icon [icon]="faCalendarDay" aria-hidden="true"></fa-icon>
          <span>Ver estado del cliente a fecha:</span>
        </div>
        <div class="hd-snapshot-controls">
          <p-calendar
            [(ngModel)]="selectedDate"
            (ngModelChange)="onDateChange($event)"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            placeholder="Selecciona una fecha"
            appendTo="body"
            [baseZIndex]="2000"
            inputId="snapshot-date"
            class="hd-calendar"
          ></p-calendar>
        </div>
        @if (selectedDate) {
          <button class="hd-clear-btn" (click)="clearDate()" aria-label="Limpiar fecha seleccionada">
            <fa-icon [icon]="faEraser" aria-hidden="true"></fa-icon>
            Limpiar fecha
          </button>
        }
        @if (selectedDate) {
          <p class="hd-snapshot-hint">
            Mostrando cambios hasta el <strong>{{ selectedDate | date:'dd/MM/yyyy' }}</strong>
          </p>
        }
      </section>

      <!-- Audit table -->
      <section class="hd-body">
        <div class="hd-count-row">
          <span class="hd-count-badge" [attr.aria-label]="filteredRecords.length + ' operaciones'">{{ filteredRecords.length }}</span>
          <span class="hd-count-label">operaci{{ filteredRecords.length !== 1 ? 'ones' : 'ón' }}</span>
        </div>

        @if (loading) {
          <div class="hd-empty" role="status" aria-live="polite">
            <p>Cargando historial...</p>
          </div>
        } @else if (filteredRecords.length > 0) {
          <div class="hd-table-wrapper">
            <table class="hd-table" aria-label="Historial de cambios del cliente">
              <thead>
                <tr>
                  <th scope="col" class="col-chevron"></th>
                  <th scope="col">Fecha</th>
                  <th scope="col">Operación</th>
                  <th scope="col">Usuario</th>
                </tr>
              </thead>
              <tbody>
                @for (record of filteredRecords; track record.id) {
                  <!-- Summary row -->
                  <tr
                    class="hd-row-summary"
                    [class.is-expanded]="isExpanded(record.id)"
                    [class.not-expandable]="!isExpandable(record)"
                    (click)="isExpandable(record) && toggleExpand(record.id)"
                    [attr.aria-expanded]="isExpandable(record) ? isExpanded(record.id) : null"
                    [attr.aria-controls]="isExpandable(record) ? 'detail-' + record.id : null"
                  >
                    <td class="col-chevron">
                      @if (isExpandable(record)) {
                        <fa-icon
                          [icon]="faChevronRight"
                          class="hd-chevron"
                          [class.rotated]="isExpanded(record.id)"
                          aria-hidden="true"
                        ></fa-icon>
                      }
                    </td>
                    <td class="col-date">{{ record.date | date:'dd/MM/yyyy HH:mm' }}</td>
                    <td class="col-action">
                      <span class="action-badge" [ngClass]="'action-' + record.action">
                        {{ record.actionLabel }}
                      </span>
                    </td>
                    <td class="col-user">{{ record.user }}</td>
                  </tr>

                  <!-- Detail rows (expanded) -->
                  @if (isExpanded(record.id)) {
                    <tr class="hd-row-detail-header" [id]="'detail-' + record.id">
                      <td></td>
                      <td class="detail-col-label"><strong>Campo</strong></td>
                      @if (record.action !== 'CREATE') {
                        <td class="detail-col-before"><strong>{{ record.action === 'DELETE' ? 'Valor' : 'Antes' }}</strong></td>
                      }
                      @if (record.action !== 'DELETE') {
                        <td class="detail-col-after"><strong>{{ record.action === 'CREATE' ? 'Valor' : 'Después' }}</strong></td>
                      }
                      <td></td>
                    </tr>
                    @for (change of record.changes; track change.field) {
                      <tr class="hd-row-detail">
                        <td></td>
                        <td class="detail-col-label">{{ change.label || change.field }}</td>
                        @if (record.action !== 'CREATE') {
                          <td class="detail-col-before">{{ formatAuditValue(change.before) }}</td>
                        }
                        @if (record.action !== 'DELETE') {
                          <td class="detail-col-after">{{ formatAuditValue(change.after) }}</td>
                        }
                        <td></td>
                      </tr>
                    }
                  }
                }
              </tbody>
            </table>
          </div>
        } @else {
          <div class="hd-empty" role="status">
            <fa-icon [icon]="faClockRotateLeft" aria-hidden="true"></fa-icon>
            <p>No hay cambios registrados para este período.</p>
          </div>
        }
      </section>
    </aside>
  </div>
}
